import React from "react";

const UserContext = React.createContext({
  userProfile: {},
  userProfileReducer: () => {},
});

export default UserContext;
